import { useContext, useEffect } from "react";
import FilterContexts from "../../Variables/FilterContexts";
import useSWR from "swr";
import axios from "axios";
import { LogInURL, urlHeader } from "../../Variables/variable";
import { toast } from "react-toastify";

const datasToUrl = {name: "name", patientId: "patient_id", page: "page", perpage: "per_page"}
const toDrug = {name: "drug", freq: "drug_frequency", duration: "drug_due_day"}
const fetcher = async(url, bearerToken, isAskPdf) => {
    // console.log(bearerToken)
    const response = await fetch(url, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${bearerToken}`
        }
    })
    // console.log('fetcher:',response)

    if(!response.ok){throw new Error(response.statusText)}

    return await isAskPdf ? response.blob() : response.json();
};

const axiosInstance = axios.create({
    baseURL: urlHeader,
    headers: {
        Accept: 'application/json',
        Authorization: `Bearer token`
    }
})

axiosInstance.interceptors.request.use(
    (config) => {
        let accessToken = sessionStorage.getItem('access_token');
        if(accessToken){config.headers.Authorization = `Bearer ${accessToken}`;}
        return config;
    },
    (error) => {
        // console.log('catch error:', error)
        return Promise.reject(error);
    }
)

// for refresh token
axiosInstance.interceptors.response.use(
    (response) => {
        if(response.data.message)toast.success('成功')
        return response;
    },
    async(error) => {
        console.log('error in handleAxiosError',error)
        if(error.response.status !== 401){
            if(error.response.data.message){
                let errMsg = error.response.data.message;
                if(window.location.pathname==='/home/basic_info' && errMsg==='The record id has already been taken.')errMsg = `請檢查是否已將患者的檢查紀錄及用藥紀錄全部刪除`;
                toast.error(errMsg)
            }
        }
        const originalRequest = error.config;
        if(error.response.status === 401 && !originalRequest._retry){
            originalRequest._retry = true;
            const refreshToken = sessionStorage.getItem('refresh_token');
            // if(refreshToken){
            //     try{
            //         const response = await axios.post(`${urlHeader}user/refresh`, {refresh_token: refreshToken});
            //         console.log('refreshed:',response)
            //         if(response.data.error)throw new Error(response.data.error);
            //         const newAccessToken = response.data.access_token;
            //         const newRefreshToken = response.data.refresh_token;
            //         sessionStorage.setItem('access_token', newAccessToken);
            //         sessionStorage.setItem('refresh_token', newRefreshToken);
            //         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            //         return axios(originalRequest);
            //     }
            //     catch(error){
                    console.log('fail to refresh token')
                    alert('登入逾時，請重新登入')
                    sessionStorage.setItem('isLoggedIn', false);
                    sessionStorage.setItem('access_token', null);
                    window.location.href = '../../'
            //     }
            // }
        }
    }
)

export async function GetToken( loginData ){
    // let finalUrl = `${urlHeader}user/login`;

    // try{
    //     const response = await axios.post(finalUrl, loginData)
    //     return response.data;
    // }
    // catch(error){
    //     throw error;
    // }
    return {access_token: localStorage.getItem("token")}
}

async function GetNewAccessToken(){
    const refreshToken = sessionStorage.getItem('refresh_token');
    // console.log('refresh_roken', refreshToken)
    try{
        const response = await axios.post(`${urlHeader}user/refresh`, {refresh_token: refreshToken});
        console.log('get new response',response)
        if(!response.data || !response.data.access_token){
            throw new Error('fail to refresh token')
        }
        const newAccessToken = response.data.access_token;
        const newRefreshToken = response.data.refresh_token;
        sessionStorage.setItem('access_token', newAccessToken);
        sessionStorage.setItem('refresh_token', newRefreshToken);
    }
    catch(error){
        throw error;
    }
}

export function GetSearchData( targetPath, isAskPdf ){
    const {datas} = useContext(FilterContexts);
    let finalUrl = `${urlHeader}${targetPath}`;

    // test refresh
    // sessionStorage.setItem('access_token', null)
    // sessionStorage.setItem('refresh_token', null)

    // if(datas.patientId!=='' && datas.patientId!==null && targetPath==="client_data"){finalUrl  = finalUrl + "/search?patient_id=%"+datas.patientId+"%";}
    if(targetPath==="client_data" && (datas.name!=='' || datas.patientId!=='' || datas.page!=='' || datas.perpage!=='')){
        finalUrl = finalUrl+"/search?";
        let urlFilter = '';
        Object.keys(datas).forEach((item) => {
            if(datas[item]!==''){
                let cond = item==="perpage" || item==="page" ? '' : '%25';
                if(urlFilter.length>0) urlFilter += '&';
                urlFilter += datasToUrl[item] + "=" + cond +datas[item] + cond;
            }
        })
        finalUrl = finalUrl + urlFilter;
        console.log(finalUrl)
    }

    const { data: returnData, error, mutate } = useSWR(
        targetPath ? finalUrl : null,
        () => fetcher(finalUrl, sessionStorage.getItem('access_token'), isAskPdf),
        {
            onErrorRetry: (error, key, config, revalidate, {retryCount}) => {
                console.error('fail to fetch:', error.message);

                if(error.message === 'Unauthorized'){
                    if(sessionStorage.getItem('refresh_token'))GetNewAccessToken()
                    .then(() => {
                        setTimeout(() => revalidate(), 500);
                    })
                    .catch((refreshError) => {
                        console.log('fail to refresh token', refreshError);
                        alert('登入逾時，請重新登入')
                        window.location.href = LogInURL;
                        sessionStorage.setItem('isLoggedIn', false);
                        sessionStorage.setItem('access_token', null);
                        sessionStorage.setItem('refresh_token', null)
                    })
                    return sessionStorage.getItem('refresh_token')!=='null';
                }
                else{
                    return false
                }
            }
        }
    );
    // console.log("url:",finalUrl);
    useEffect(() => {
        if(datas.patientId!==''){
            mutate();
        }
    }, [datas.patientId, mutate])

    useEffect(() => {
        if(isAskPdf){
            console.log(datas.PdfType)
        }
    }, [datas.PdfType, isAskPdf])
    
    if(error) {
        if(error.message==='Not Found') return("not found")
        if(error.message!=='Unauthorized'){
            console.log("發生認證以外錯誤：",error)
            return 'some error occurred';
        }
    }
    if(!returnData) return("loading...")
    return (returnData)
}

export async function GetPDFFileList( url ){
    // console.log(url);
    const response = await axiosInstance.get(url);
    return response.data ? response.data : [];
}

export async function GetPDFWithFilename( url ){
    const response = await axiosInstance.get(url, {
        responseType: 'blob'
    })
    return response.data
}   

async function axiosPost(url, data){
    try{
        const response = await axiosInstance.post(url, data)
        console.log('post 成功:', response.data);
        return {success: true, data: response.data};
    }
    catch(error){
        console.error('post 發生錯誤:', error);
        console.log(error)
        return {success: false, error: error.message};
    }
}

function axiosPatch(url, data){
    axiosInstance.patch(url, data)
    .then(response => {
        console.log('patch 成功:', response.data);
    })
    .catch(error => {
        console.error('patch 發生錯誤:', error);
    })
}

function axiosDelete(url){
    axiosInstance.delete(url)
    .then(response => {
        console.log('delete 成功:', response.data);
    })
    .catch(error => {
        console.error('delete 發生錯誤:', error);
    })
}

function deleteRecord(recordList, newUrl){
    recordList.forEach((record_id) => {
        let finalUrl = `${newUrl}/${record_id}`;
        axiosDelete(finalUrl)
    })
}

//for AddDrugRecord
export async function SendDrugRecord( webpageRecord, client_data_record_id){
    let newUrl = "/drug_record";

    if(webpageRecord.deleteIDList.length>0){
        deleteRecord(webpageRecord.deleteIDList, newUrl)
    }

    if(Object.keys(webpageRecord.updateList).length>0){
        Object.entries(webpageRecord.updateList).forEach(([start_date, records]) => {
            Object.entries(records).forEach(([index, record]) => {
                let temData = {}
                Object.entries(record).forEach(([key, value]) => {
                    if(toDrug[key])temData[toDrug[key]] = value==='' ? null : value;
                })
                if(!record.record_id || record.record_id===''){
                    temData.start_date = start_date;
                    temData.client_data_record_id = client_data_record_id;
                    //post
                    axiosPost(newUrl, temData)
                }           
                else{
                    let finalUrl =`${newUrl}/${record.record_id}`;
                    //patch
                    axiosPatch(finalUrl, temData);
                }
            })
        })
    }

    }
//for PDF
async function uploadPDF( eye_record_record_id, file_type, uploadList ){
    uploadList.forEach((file) => {
        const formData = new FormData();
        formData.append('file', file.file);
        formData.append('filename', file.fileName);

        axiosInstance.post(`/test_pdf/${eye_record_record_id}/${file_type}`, formData)
        .then(response => {
            console.log("PDF上傳成功", response.data)
        })
        .catch(error => {
            console.log("PDF上傳失敗", error)
        })
    })
}

async function deletePDF( eye_record_record_id, file_type, deleteList ){
    deleteList.forEach((filename) => {
        axiosDelete(`/test_pdf/${eye_record_record_id}/${file_type}/${filename}`)
    })
}

//for AddExamineRecord 
export async function SendEyeRecord(webpageRecord, client_data_record_id){
    let newUrl = "/eye_record";

    if(webpageRecord.deleteIOPList.length>0){
        deleteRecord(webpageRecord.deleteIOPList, "/iop_record");
    }

    //delete PDF
    if(Object.keys(webpageRecord.PDFUpdateList).length > 0){
        Object.entries(webpageRecord.PDFUpdateList).forEach(([date, content]) => {
            Object.entries(content).forEach(([type, lists]) => {
                if(lists.deleteList.length>0) deletePDF(webpageRecord[date].record_id, type, lists.deleteList);
            })
        })
    }

    if(Object.keys(webpageRecord.updateList).length>0){
        Object.entries(webpageRecord.updateList).forEach(([test_date, records]) => {
            if(records.isNewRecord){
                // delete
                if(records.record_id)axiosDelete(`${newUrl}/${records.record_id}`)
                let isAllNull = Object.entries(webpageRecord[test_date])
                .filter(([key, value]) => key!=="isNewRecord" && key!=="record_id" && key!=="test_date")
                .every(([key, value]) => {return value===null || value.length===0});
                console.log("isAllNull:",isAllNull)
                // post
                if(!isAllNull){
                    let postData = webpageRecord[test_date];
                    let temData = webpageRecord[test_date].iop_records;
                    delete postData.iop_records;
                    delete postData.isNewRecord;
                    delete postData.record_id;
                    postData.client_data_record_id = client_data_record_id;
                    postData.test_date = test_date;
                    axiosInstance.post(newUrl, postData)
                    .then(firstResponse => {
                        console.log("成功: ", firstResponse.data);

                        //upload IOP after success
                        if(temData.length>0){
                            temData.forEach((record) => {
                                let postIOPData = record;
                                postIOPData.eye_record_record_id = firstResponse.data.record_id;
                                delete postIOPData.record_id;
                                console.log(postIOPData)
                                axiosInstance.post("/iop_record", postIOPData)
                                .then(secondResponse => {
                                    console.log("IOP上傳成功: ",secondResponse.data)
                                })
                                .catch(error => {
                                    console.log("IOP上傳失敗: ", error)
                                })
                            })
                        }

                        Object.entries(webpageRecord.PDFUpdateList[test_date]).forEach(([type, lists]) => {
                            console.log(type, lists)
                            if(lists.uploadList.length>0) {
                                uploadPDF(firstResponse.data.record_id, type, lists.uploadList)
                            }
                        })
                    })
                    .catch(error => {
                        console.error('發生錯誤:', error);
                    })
                }
            }
            else{
                let patchEyeData = records;
                if(records.IOP && Object.keys(records.IOP).length>0){
                    Object.entries(records.IOP).forEach(([index, record]) => {
                        if(!record.record_id){
                            let postData = record;
                            delete postData.record_id;
                            postData.eye_record_record_id = webpageRecord[test_date].record_id;
                            console.log(postData)
                            axiosPost("/iop_record", postData)
                        }
                        else{
                            let patchData = record;
                            let record_id = record.record_id;
                            delete patchData.record_id;
                            console.log("pathch:", patchData)
                            axiosPatch(`/iop_record/${record_id}`, patchData)
                        }
                    })
                    delete patchEyeData.IOP;
                }

                Object.entries(webpageRecord.PDFUpdateList[test_date]).forEach(([type, lists]) => {
                    if(lists.uploadList.length>0) {
                        uploadPDF(webpageRecord[test_date].record_id, type, lists.uploadList)
                    }
                })

                if(patchEyeData && Object.keys(patchEyeData).length>1){
                    let record_id = patchEyeData.record_id;
                    delete patchEyeData.record_id;
                    console.log("patch:", patchEyeData)
                    axiosPatch(`${newUrl}/${record_id}`, patchEyeData);
                }
                
            }
        })
    }    
}

//for AddPatientData
export async function SendPatientData(webpageRecord, client_data_record_id){
    if(client_data_record_id){
        if(webpageRecord.updateList && webpageRecord.updateList.length>0){
            //patch
            let patchData = {};
            await webpageRecord.updateList.forEach((item) => {
                patchData[item] = webpageRecord[item];
            })
            axiosPatch(`/client_data/${client_data_record_id}`, patchData);
        }
    }
    else{
        //post
        if(!webpageRecord.patient_id || !webpageRecord.citizen_id){
            // alert("請輸入身分證以及病例號")
            console.log(webpageRecord)
            return {success: false, message: "請輸入身分證以及病例號"};
        }
        // if(!checkCitizen(webpageRecord.citizen_id)){
        //     alert("身分證輸入有誤")
        //     return;
        // }
        const postData = webpageRecord;
        delete postData.record_id;
        delete postData.updateList;
        console.log(postData)
        return await axiosPost('/client_data', postData);
    }
}

// function checkCitizen(citizenId){
//     const weight = [1,9,8,7,6,5,4,3,2,1]
//     let checkCode = citizenId[9];
//     let EngToNum = citizenId[0].charCodeAt() - 65 + 10;

//     if(EngToNum < 0 || EngToNum > 33) return false;

//     let newString = EngToNum.toString() + citizenId.slice(1,9);
//     let checkSum = 0;
//     for (let i=0;i<10;i++){
//         checkSum += parseInt(newString[i])*weight[i];
//     }
    
//     console.log(checkSum)
//     if((10-(checkSum%10))%10 === parseInt(checkCode)){return true};

//     return false
// }

export function DeletePatient(record_id){
    let confirmed = window.confirm("確認刪除？");
    if(confirmed){
        axiosDelete(`/client_data/${record_id}`)
    }
}

export function postForm(data){
    console.log('post form:',data)
    // axiosPost("/form", data)
}  